import styled from "styled-components";
import { colorToken } from "components/utils/constants";
import breakpoint from "components/utils/responsive";
import { Link } from 'react-router-dom';
export const ReturnTheme = (theme) => {
    const objThemes = {
        theme1: {
            background: colorToken.black,
            linkColor: colorToken.white,
            linkColorHover: colorToken.color2,
        },
        theme2: {
            background: colorToken.color1,
            linkColor: colorToken.color2,
            linkColorHover: colorToken.color3,
        },
        theme3: {
            background: colorToken.color2,
            linkColor: colorToken.white,
            linkColorHover: colorToken.color1,
        },
    };

    return objThemes[theme] || objThemes.theme1;
};

export const LogoVw = () => (
    <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.22 112.22">
        <g id="c">
            <path
                d="m56.11,112.22c31.03,0,56.11-25.08,56.11-56.11C112.22,25.08,87.15,0,56.11,0,25.08,0,0,25.08,0,56.11c0,31.03,25.08,56.11,56.11,56.11m-16.22-30.8c-.31,0-.47-.31-.63-.63L13.4,28.68c4.62-7.05,10.81-13.01,18.26-17.16l18.57,41.38c.31.78.78.94,1.41.94h8.93c.63,0,1.1-.16,1.41-.94l18.57-41.38c7.44,4.15,13.64,10.11,18.26,17.16l-25.86,52.11c-.16.31-.31.63-.63.63-.31,0-.47-.31-.63-.63l-9.72-22.26c-.31-.78-.78-.94-1.41-.94h-8.93c-.63,0-1.1.16-1.41.94l-9.72,22.26c-.16.31-.31.63-.63.63m16.22-36.83c-.31,0-.47-.31-.63-.63l-15.99-35.89c5.17-1.88,10.81-2.9,16.61-2.9s11.44,1.02,16.61,2.9l-15.99,35.89c-.16.31-.31.63-.63.63m0,62.46c-27.9,0-50.78-23.04-50.78-50.94,0-6.27,1.1-12.23,3.21-17.79l29.7,59.8c.39.79.86,1.41,1.8,1.41.94,0,1.46-.64,1.8-1.41l13.64-30.64c.16-.31.31-.63.63-.63.31,0,.47.31.63.63l13.64,30.64c.34.77.86,1.41,1.8,1.41.94,0,1.41-.62,1.8-1.41l29.7-59.8c2.12,5.56,3.21,11.52,3.21,17.79,0,27.9-22.88,50.94-50.78,50.94"
                style={{ fill: colorToken.color1, strokeWidth: "0px" }}
            />
        </g>
    </svg>
);

export const StyleHeader = styled.header`
    position: fixed;
    padding: 16px;
    width: 100%;
    top: 0;
    z-index: 100;
    transition: all 0.2s;
    background-color: ${colorToken.white};

    svg {
        width: 35px;
    }

    > div {
        max-width: 960px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        > div {
            display: flex;
            align-items: center;
            &:last-of-type {
                justify-content: flex-end;
            }
            &:first-of-type {
                
            }
        }
    }

    &.is-sticky {
    }

    @media ${breakpoint.lg} {
        > div {
        > div {
            &:last-of-type {

            }
            &:first-of-type {
                flex-grow: 1;
                flex-basis: 0;
            }
        }
    }
    }
`;

export const StyleVolksHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0 20px;
    padding: 12px 0;
    svg {
        width: 39px;
    }
    @media ${breakpoint.lg} {
        padding: 12px 0;
    }
`
export const StyleLineLeft = styled.div`
    height: 2px;
    border-radius: 0 1px 1px 0;
    background-color: ${colorToken.white};
    flex-grow: 1;
    box-shadow: 1px 0 rgba(0,71,118, 0.4);
`
export const StyleLineRight = styled.div`
    height: 2px;
    border-radius: 1px 0 0 1px;
    background-color: ${colorToken.white};
    flex-basis: 16%;
`
export const StyleLogo = styled.div`
    flex-basis: 42px;
    @media ${breakpoint.lg} {
        flex-basis: 42px;
    }
`

export const StyleMenu = styled.nav`
    margin: 0 auto;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.95);
    top: 65px;
    display: flex;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${({ showMenu }) => (showMenu ? "calc(100vh - 55px)" : "0vh")};
    padding-top: ${({ showMenu }) => (showMenu ? "16px" : "0")};
    transition: all linear 0.4s;
    flex-direction: column;
    overflow: hidden;
    @media ${breakpoint.lg} {
        position: unset;
        height: unset;
        display: flex;
        flex-direction: row;
        padding: 0;
        gap: 0 24px;
    }
`

export const StyleMenuItem = styled(Link)`
    color: ${colorToken.color2};
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    padding: 16px 24px;
    @media ${breakpoint.lg} {
        /* display: flex;
        gap: 0 24px; */
        padding: 0;
    }
    `

export const StyleButtonHamburger = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    padding: 0;
    width: 32px;
    margin-left: 8px;
    .line {
        fill: none;
        stroke: ${colorToken.color2};
        stroke-width: 6;
        transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
            stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
    }
    .line1 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
    }
    .line2 {
        stroke-dasharray: 60 60;
        stroke-width: 6;
    }
    .line3 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
    }
    &.opened .line1 {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
    }
    &.opened .line2 {
        stroke-dasharray: 1 60;
        stroke-dashoffset: -30;
        stroke-width: 6;
    }
    &.opened .line3 {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
    }
    @media ${breakpoint.lg} {
        display: none;
    }
`;